module.exports = __webpack_public_path__ + "img/forgetPwd.3d93846f.png";